// src/utils/theme.js
const THEME_KEY = 'themePref'; // cache to avoid flashes between loads

function setDark(isDark) {
  const root = document.documentElement;
  if (isDark) root.setAttribute('data-theme', 'dark');
  else root.removeAttribute('data-theme'); // light = default :root
}

let boundSystemListener = false;
let mq;

export function applyThemePref(pref = 'system') {
  // Cache for instant subsequent loads
  try { localStorage.setItem(THEME_KEY, pref); } catch {}

  // Lazy-init matchMedia
  if (!mq && typeof window !== 'undefined') {
    mq = window.matchMedia('(prefers-color-scheme: dark)');
  }

  if (pref === 'dark') {
    setDark(true);
  } else if (pref === 'light') {
    setDark(false);
  } else {
    // system
    setDark(mq ? mq.matches : false);
    if (mq && !boundSystemListener) {
      mq.addEventListener?.('change', (e) => {
        // Follow system only if user pref == system
        let current = 'system';
        try { current = localStorage.getItem(THEME_KEY) || 'system'; } catch {}
        if (current === 'system') setDark(e.matches);
      });
      boundSystemListener = true;
    }
  }
}

/** Run ASAP on app boot to avoid white flash before profile loads */
export function initThemeFromCache() {
  let cached = null;
  try { cached = localStorage.getItem(THEME_KEY); } catch {}
  applyThemePref(cached || 'system');
}
